<template>
  <div class="go-back">
    <el-button
      v-if="this.formisactive == false && this.logsOfIssueOnMobile == false && this.$route.name != 'DashboardAllProperties' && 
      this.routeHistory[1] != null && this.routeHistory[1] != undefined"
      icon="el-icon-back"
      circle
      @click="goBack()"
      class="b-button"
    ></el-button>
    <el-button v-if="this.formisactive == true" icon="el-icon-close" @click="closeForm()" circle class="b-button"></el-button>
    <el-button
      v-if="this.logsOfIssueOnMobile == true && this.formisactive == false"
      icon="el-icon-close"
      circle
      @click="closeLogsOfIssuesOnMobile()"
      class="b-button"
    ></el-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {

  data() {
    return {
      formisactive: false,
      logsOfIssueOnMobile: false,
      routeHistory: [],
      calculateButtonPress: 0,
      routeIsFromBackButton: false
    };
  },
    mounted() {
     this.routeHistory = this.$store.state.backbutton.routeHistory;

    //if user loads page in the middle of the website with no history in the router we define where to navigate

    //this checks if second index position is empty, because the first has the current route
        
          if(this.routeHistory[1] == null || this.routeHistory[1] == undefined){
         var route = this.$route.path;

                  if(route.toLowerCase().includes("propertybyid")){

                           this.routeHistory.unshift("/DashboardAllProperties");

                  } else if(route.toLowerCase().includes("allissues")) {

                             this.routeHistory.unshift("/DashboardAllProperties");
                  } else if(route.toLowerCase().includes("inbox")) {

                             this.routeHistory.unshift("/DashboardAllProperties");
                  } else if(route.toLowerCase().includes("reports")) {

                             this.routeHistory.unshift("/DashboardAllProperties");
                  } else if(route.toLowerCase().includes("feedback")) {

                             this.routeHistory.unshift("/DashboardAllProperties");

                  } else if(route.toLowerCase().includes("machinebyid")){
                    //if the route is machine by id do nothing, its handled in mounted() of AssetsLogsAndIssues.vue
                    return
                  }
         }
  },
  computed:{
  },
  watch:{
    //this function is called every time the browser routes to a new route anywhere in the app
          $route: function() {
  //the back button leads on every click to one index earlier in the route array (this.routeHistory) as long as you click,
  // here the goal is  to reset the back button to begin again at the last index of the array if a user navigates to route 
  //not from the back button

         var fullRoute = this.$route.fullPath;
         var routeWithoutHash = this.$route.path;

        //this if checks that the route is not from the back button and also if it's not a # link because certain components
        //push in # every time the page is loaded and if you load them with the back button it shouldn't reset the button order
        if(this.routeIsFromBackButton == false  && !fullRoute.includes("#")){
          this.calculateButtonPress = 0;
          //this is needed for if a user loads a # route, i still wanna check if it's new route and not just a component pushed it in
          //because in that case i do want to reset the back button since it's a new route. the way it's checked is if this route doesn't
          //match the last saved route (third condition) then it's a new route 
        } else if(this.routeIsFromBackButton == false && fullRoute.includes("#") && routeWithoutHash != this.routeHistory[this.routeHistory.length - 1] ){

          this.calculateButtonPress = 0;
        }
        this.routeIsFromBackButton = false;
    }
},
  methods: {
    // ...mapActions(["toggleformactive"]),
    goBack() {     
      
       this.routeIsFromBackButton = true;
      //the route is taken from the last position in the array backwards, so on the first press it leads to one before the last
      //this is nmber 2, on the second press you can't go to 3 since the first button press leads to a new route and the array 
      //saved already this route also so you need index 4. so every time it leads up 2 positions
      this.calculateButtonPress += 2;

      //this is a way to get values of the array backwards, minus 1 will be last position minus 2 will be one before last and so on
       this.$router.replace(this.routeHistory[this.routeHistory.length - this.calculateButtonPress ]);
     
    },
    handleFormOpened() {
      this.toggleForm();
    },
    handleLogsOfIssueOnMobile() {
      this.logsOfIssueOnMobile = true;
    },
    toggleForm() {
      this.formisactive = !this.formisactive;
    },
    closeForm() {
      this.$root.$emit("close-form");
      this.toggleForm();
    },
    closeLogsOfIssuesOnMobile() {
      this.logsOfIssueOnMobile = false;
      this.$root.$emit("close-logs-of-issues-on-mobile");
    }
  },
  created() {
    this.$root.$on("form-toggled", () => this.handleFormOpened());
    this.$root.$on("logs-of-issue-on-mobile", () =>
      this.handleLogsOfIssueOnMobile()
    );
    this.$root.$on("switched-notes-to-logs-mobile", () => 
      this.closeLogsOfIssuesOnMobile()
    );
  }
};
</script>

<style scoped>
.go-back {
  cursor: pointer;
  margin-left: 10px;
  
}
.b-button{
  margin-top: 10px;
}
</style>
